import { compose } from 'redux';

import {
  HOTEL_LIST_SORT_VALUES,
  PLAN_DETAIL_SORT_VALUES,
  PLAN_LIST_SORT_VALUES,
} from 'constants/sort';

export const isClient = typeof window !== 'undefined';

export const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    isClient &&
    window &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export const MONTEROSA_API_TIMEOUT = 60000;

export const getIPAddress = (req: Request | undefined) => req?.headers['x-real-ip'];
export const isInSortCategory = (
  sortCategory:
    | typeof HOTEL_LIST_SORT_VALUES
    | typeof PLAN_LIST_SORT_VALUES
    | typeof PLAN_DETAIL_SORT_VALUES,
  sortQuery: string | undefined,
) => {
  const sortValues = Object.values(sortCategory) as Array<string>;
  return !!sortQuery && sortValues.includes(sortQuery);
};
